const MODULE_NAME = 'PASSWORD_EDIT';
const PASSWORD_EDIT_SUBMIT = MODULE_NAME + 'SUBMIT';
const PASSWORD_EDIT_COMPLETED = MODULE_NAME + 'COMPLETED';
const PASSWORD_EDIT_FAILED = MODULE_NAME + 'FAILED';
const PASSWORD_EDIT_FORM_RESET = MODULE_NAME + 'FORM_RESET';

export {
  PASSWORD_EDIT_COMPLETED,
  PASSWORD_EDIT_FAILED,
  PASSWORD_EDIT_FORM_RESET,
  PASSWORD_EDIT_SUBMIT
};
